module.exports = __webpack_public_path__ + "static/media/Liquidity-background.ae8d8e55.jpg";